<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-09-22 19:20:18
-->
<template>
  <div class="back themeGreen" @click="handleBack">
    <i class="el-icon-back" style="margin-right: 4px" />
    <span>{{ $t("public.goBack") }}</span>
  </div>
</template>

<script>
export default {
  name: "Back",
  props: {},
  methods: {
    handleBack() {
      if (!this.$store.state.addFormVisible) {
        this.$router.back();
      } else {
        this.$store.state.addFormVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.back {
  line-height: 20px;
  display: inline-block;
  margin-bottom: 3px;
  font-size: 14px;
  cursor: pointer;
}
</style>
